// extracted by mini-css-extract-plugin
export default {"container":"page-module__container___2TXqA","contentHeader":"page-module__contentHeader___2g1Rr"};